import React, { FC } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { SimpleButtonProps } from "../types";
import useSimpleButtonStyles from "./styles";
import { useMediaQuery } from "@mui/material";
import classNames from "classnames";
const SimpleButton: FC<SimpleButtonProps> = ({
  primary,
  disable,
  loading,
  text,
  onClick,
  className,
  exitDemoStyles
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const classes = useSimpleButtonStyles({
    primary,
    loading,
    text,
    onClick,
    className,
    disable,
    exitDemoStyles
  });

  return (
    <Button
      onClick={onClick}
      className={classNames(
        classes.button,
        {
          [classes.primary]: primary,
          [classes.secondary]: !primary,
          [classes.mobile]: isMobile,
          [classes.disable]: disable,
          [classes.loading]: loading,
        },
        className
      )}
    >
      {loading ? (
        <CircularProgress className={classes.loader} />
      ) : (
        <Typography
          className={classNames(classes.text, {
            primary: primary,
            secondary: !primary,
            disable: disable,
                exitDemoStyles: exitDemoStyles,
          })}
        >
          {text}
        </Typography>
      )}
    </Button>
  );
};

export default SimpleButton;
